import * as React from 'react'

import {
  Box,
  Typography,
  CircularProgress,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell
} from '@mui/material'
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import { useDispatch, useSelector } from 'react-redux';

import { CActionButton } from '../../components/common/Button'
import UploadButton from '../UploadButton'
import Axios from 'axios';
import { API_URI } from '../../const';
import { getTemplate } from '../../slices/utils';

export default function Template(props) {
  const templates = useSelector(state => state.utils.templates);
  const [uploading, setUploading] = React.useState(false);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(getTemplate())
  }, [dispatch])

  const handleUpload = (e) => {
    const template = e.target.files[0];
    let formData = new FormData();
    formData.append("file", template);
    
    if(template) {
      setUploading(true);
      Axios.post(`${API_URI}/v1/user/chat/upload_template`, formData)
        .then(res => {
          if(res.status === 200)
            window.confirm(`${res.data.name} uploaded successfully.`)
          dispatch(getTemplate())
          setUploading(false);
        })
        .catch(err => {
          console.error('Error:', err);
          setUploading(false);
        });
    }
  }

  return (
    <Box className='w-full h-full flex flex-column'>
      <Box className='w-full flex flex-row section-title-height'>
        <Typography 
          sx={{ 
            fontSize: 16, 
            fontWeight: 400, 
            padding: 2,
          }}
          className='flex-basis'
        >
          PowerPoint Templates
        </Typography>
        <UploadButton 
          variant='contained' 
          handleUpload={handleUpload}
          disabled = {uploading}
        >
          Add New Template
        </UploadButton>
      </Box>
      <Box className='flex-basis'>
          {uploading ? (<Box className="w-full h-full flex justify-center align-center">
              <CircularProgress/>
            </Box>) : (<TableContainer size="small">
              <Table sx={{ minWidth: 650, height: '100%' }} size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>                    
                    <TableCell sx={{width: 120}}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {
                  templates.map(item => (
                    <TableRow
                      key={item}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 }, height: 50 }}
                    >
                      <TableCell>{item}</TableCell>
                      <TableCell>
                        <CActionButton 
                          startIcon={<BorderColorIcon/>}
                          // onClick={() => handleEdit(source.id)}
                        />
                        <CActionButton 
                          startIcon={<DeleteOutlineIcon/>}
                          // onClick={() => handleDelete(source.id)}
                        />
                      </TableCell>
                    </TableRow>
                  ))
                }
                </TableBody>
              </Table>
            </TableContainer>
            )
          }
      </Box>
    </Box>
  )
}